const messages = {
  intro: {
    continue: "Scroll to continue"
  },
  district: {
    download: 'Download',
    share: 'Share',
    help: 'Help',
    readFull: 'Full screen mode',
    noContent: 'No content Found'
  },
  auditorium: {
    nextEvent: 'Next Event',
    enter: 'Enter the auditorium'
  },
  account: {
    name: 'Name' ,
    surname: 'Surname',
    company: 'Company',
    role: 'Role',
    profile: 'Profile',
    picture: 'Change picture',
    yourPicture: 'Your picture',
    avatar: 'Create your avatar',
    also: 'Also',
    email: 'Email'
  },
  avatar: {
    random: 'Random',
    custom: 'Customize your avatar to enter in SBS Towns'
  },
  button: {
    save: 'Save',
    cancel: 'Cancel',
    next: 'Next',
    skip: 'Skip'
  },
  dropdown: {
    name: 'Name',
    company: 'Company',
    role: 'Role',
    edit: 'Edit',
    favorites: 'My favorites',
    close: 'Close',
    logout: 'Logout'
  },
  login: {
    first: 'First time',
    back: 'I\'m back',
    title: 'Sign up to SBS town',
    microsoft: 'Sign up with your SBS account',
    titleIn: 'Sign in to SBS town',
    microsoftIn: 'Sign in with your SBS account',
    signIn: 'Sign in',
    signUp: 'Sign up',
    email: 'Email Address',
    password: 'Password',
    passwordConfirm: 'Confirm password',
    goToSbs: 'Go to SBS Town',
    backToLog: 'Back to Log in',
    forgot: 'I forgot my password ?',
    verify: 'You will receive a mail to verify',
    signIn: 'Sign in',
    signUp: 'Sign up',
    send: 'Send',
    reset: 'Reset password',
    resetConfirm: 'If your mail is registered, a mail has been send for you to change your password.',
    backToLogin: 'Back to sign in',
    error: {
      confirm: 'Passeword and Password confirmation should be the same.',
      length: 'Password should be at least 8 characters long with 1 capital and 1 digit.',
      mail: 'Email Address should be a valid.',
      default: 'Invalid login.'
    },
    alreadySign: 'Already a member ? Sign in',
    alreadyCreate: 'Not a membre? Create an account'
  }
}

export default messages
